import { render } from "./Cloze.vue?vue&type=template&id=76c17cbc&scoped=true"
const script = {}

import "./Cloze.vue?vue&type=style&index=0&id=76c17cbc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76c17cbc"

export default script